"use client";

import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	buttonStyle?: string;
	isLoading?: boolean;
	children?: ReactNode;
}

export function Button({
	buttonStyle,
	className,
	children,
	isLoading = false,
	disabled,
	type = "button",
	...props
}: ButtonProps) {
	return (
		<button
			type={type}
			{...props}
			className={cn(
				"btn !shadow-none",
				buttonStyle,
				className,
				(disabled || isLoading) && "btn-disabled"
			)}
			disabled={disabled || isLoading}
		>
			{isLoading ? (
				<span className="loading loading-spinner" aria-hidden />
			) : null}
			<span className={cn(isLoading && "ml-2")}>{children}</span>
		</button>
	);
}
